<template>
  <div class="bg-orange-pastel p-4 rounded-lg">
    <div v-if="videos.length > 0">
      <div v-for="(item, index) in videos" :key="index" class="md:flex mb-6 last:mb-0">
        <div class="flex mb-2">
          <a href="#" @click.stop.prevent="onClickMultimedia(item.video.url, null, showAlways)">
            <nuxt-img
              :key="item.video.media.url"
              :alt="item.video.media.alternativeText"
              :src="item.video.media.url"
              class="w-full rounded-md md:w-36"
              loading="lazy"
            />
          </a>
          <h3 class="md:hidden text-sm ml-3 w-3/4 font-semibold text-gray-dark">
            <a href="#" @click.stop.prevent="onClickMultimedia(item.video.url, null, showAlways)">
              {{ item.video.title }}
            </a>
          </h3>
        </div>
        <div class="md:ml-2 w-full md:w-3/4">
          <h3 class="mb-4 hidden md:block text-base font-semibold text-gray-dark">
            <a href="#" @click.stop.prevent="onClickMultimedia(item.video.url, null, showAlways)">
              {{ item.video.title }}
            </a>
          </h3>
          <p class="text-xs">
            <a href="#" @click.stop.prevent="onClickMultimedia(item.video.url, null, showAlways)">
              {{ item.video.abstract }}
            </a>
          </p>
        </div>
      </div>
    </div>
    <div v-if="files.length" class="mt-2">
      <p class="font-ubuntu font-bold mb-4 mt-6 lg:mt-0">
        {{ $t('formation.courses.material.materialDownload') }}
      </p>
      <div v-for="(item, index) in files" :key="index" class="flex items-center mb-4">
        <icon name="pt-document-pdf" class="text-xl text-red mr-3 font-bold" />
        <button
          class="text-sm lg:text-base underline text-left font-semibold text-gray-dark"
          type="button"
          @click="
            $store.getters['auth/getByField']('loggedIn') || showAlways
              ? onClickPdf(item.filename, index, showAlways)
              : redirectLogin(true, item.filename, index)
          "
        >
          {{ $t('ui.button.download') + ': ' + item.name }}
        </button>
      </div>
    </div>
    <Player ref="videoPlayer" id-player="material-card" />
    <ClientOnly>
      <modal-wrapper name="errorFileDownload" width="700">
        <Confirm :message="message" />
      </modal-wrapper>
    </ClientOnly>
  </div>
</template>

<script>
import { localStorageGetObject } from '~/utils/helpers/store';
import Player from '@/components/VideoLibrary/Player';
import Confirm from '@/components/Profile/Confirm';

export default {
  name: 'MaterialCard',
  components: {
    Player,
    Confirm
  },
  props: {
    img: {
      type: String,
      default: ''
    },
    files: {
      type: Array,
      default: () => []
    },
    videos: {
      type: Array,
      default: () => []
    },
    showAlways: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const { message, onClickPdf, onClickMultimedia, redirectLogin } = useDownLoadMaterial();
    return { message, onClickPdf, onClickMultimedia, redirectLogin };
  },
  mounted() {
    setTimeout(async () => {
      const storageMaterial = localStorageGetObject('material');
      if (storageMaterial) {
        if (storageMaterial.type) {
          await this.onClickPdf(storageMaterial.url, storageMaterial.index, this.material);
        } else {
          await this.onClickMultimedia(storageMaterial.url, storageMaterial.index, this.material);
        }
      }
    }, 2000);
  }
};
</script>
